module.exports = __webpack_public_path__ + "assets/cfd79651e21262457f385eedcb0ec643.woff";